import type { ItemContent } from 'react-virtuoso';
import EmptyMessage from 'components/EmptyMessage';
import LoadingShape from 'components/LoadingShape';
import { EntityGet } from 'data/firestore/types';
import { Thread } from 'data/firestore/agent/thread/types';
import ThreadItem from './thread';
import { OpportunityStageCacheProvider } from './OpportunityStageCacheContext';
import {
    EmptyMessageContainer, EmptyMessageTitle, StyledVirtuoso,
    NotificationsContainer,
    Content,
} from './styled';

const virtuosoComponents = {
    EmptyPlaceholder: () => (
        <EmptyMessageContainer>
            <EmptyMessageTitle>
                No messages yet
            </EmptyMessageTitle>
            <EmptyMessage message="No customer messages to display yet." />
        </EmptyMessageContainer>
    ),
};

const getvVirtuosoItemContent = (
    onClickFn: ((thread: EntityGet<Thread>) => void) = () => {},
    selectedThreadId?: string,
    onUpdateSeenStatus?: (threadId: string, seenStatus: Thread['seenStatus']) => void,
// eslint-disable-next-line react/function-component-definition
) => (_listIndex: number, thread: EntityGet<Thread>) => {
    const { id } = thread;
    return (
        <ThreadItem
            isSelected={selectedThreadId === id}
            onClick={onClickFn}
            key={id}
            threadData={thread}
            onUpdateSeenStatus={onUpdateSeenStatus}
        />
    );
};

interface ThreadsListProps {
    threads?: Array<EntityGet<Thread>>;
    isLoading?: boolean;
    selectedThreadId?: string;
    onThreadSelect?: ((thread: EntityGet<Thread>) => void);
    onLoadMore?: (atBottom:boolean) => void;
    onUpdateSeenStatus?: (threadId: string, seenStatus: Thread['seenStatus']) => void;
}

const ThreadsList = ({
    threads,
    selectedThreadId,
    isLoading,
    onThreadSelect = () => {},
    onLoadMore = () => {},
    onUpdateSeenStatus,
}: ThreadsListProps) => {
    if (isLoading) {
        return (
            <Content>
                <div className="rainbow-flex rainbow-flex-grow rainbow-flex_column rainbow-p-around_small">
                    <LoadingShape height="0.75rem" width="150px" />
                    <LoadingShape height="0.75rem" width="300px" />
                    <LoadingShape height="0.75rem" width="200px" />
                </div>
            </Content>
        );
    }

    return (
        <Content>
            <NotificationsContainer>
                <OpportunityStageCacheProvider>
                    <StyledVirtuoso
                        data={threads}
                        initialTopMostItemIndex={0}
                        components={virtuosoComponents}
                        itemContent={getvVirtuosoItemContent(
                            onThreadSelect,
                            selectedThreadId,
                            onUpdateSeenStatus,
                        ) as ItemContent<unknown, unknown>}
                        atBottomStateChange={onLoadMore}
                    />
                </OpportunityStageCacheProvider>
            </NotificationsContainer>
        </Content>
    );
};

export default ThreadsList;
